
import PanelLeft from '../pages/panel-left.vue';
import HomePage from '../pages/home.vue';
import AktualnePocasiePage from '../pages/aktualne-pocasie';
import AktualnePocasieDetailPage from '../pages/aktualne-pocasie-detail';
import PredpovedPocasiaPage from '../pages/predpoved-pocasia';
import TextovaPredpovedPage from '../pages/textova-predpoved';
import MeteogramyPage from '../pages/meteogramy';
import TlakovePolePage from '../pages/tlakove-pole';
import AlaefPage from '../pages/alaef';
import OzonAUVIndexPage from '../pages/ozon-a-uv-index';
import OzonPage from '../pages/ozon';
import UVIndexPage from '../pages/uv-index';
import SnehoveSpravodajstvoPage from '../pages/snehove-spravodajstvo';
import RadaryPage from '../pages/radary';
import DruzicePage from '../pages/druzice';
import MeteoVystrahyPage from '../pages/meteo-vystrahy';
import MeteoVystrahyDetailPage from '../pages/meteo-vystrahy-detail';
import VodneStavyPage from '../pages/vodne-stavy';
import VodneStavyChartPage from '../pages/vodne-stavy-chart';
import UhrnyZrazokPage from '../pages/uhrny-zrazok';
import UhrnyZrazokChartPage from '../pages/uhrny-zrazok-chart';
import HydroVystrahyPage from '../pages/hydro-vystrahy';
import HydroVystrahyDetailPage from '../pages/hydro-vystrahy-detail';
import HydroSpravodajstvoPage from '../pages/hydro-spravodajstvo';
import HydroNadrzePage from '../pages/hydro-nadrze';
import HydroSituaciaPage from '../pages/hydro-situacia';
import SituaciaNaVodnychTokochPage from '../pages/situacia-na-vodnych-tokoch';
import SituaciaNaVodnychTokochChartPage from '../pages/situacia-na-vodnych-tokoch-chart';
import SituaciaNaVodnychTokochMesacnaChartPage from '../pages/situacia-na-vodnych-tokoch-mesacna-chart';
import PodzemneVodyPage from '../pages/podzemne-vody';
import PodzemneVodyChartPage from '../pages/podzemne-vody-chart';
import SmogovySystemPage from '../pages/smogovy-system';
import SmogovySystemDetailPage from '../pages/smogovy-system-detail';
import KoTabulka from '../pages/ko-tabulka';
import KoDetail from '../pages/ko-detail';
import WebkameryPage from '../pages/webkamery';
import WebkameryDetailPage from '../pages/webkamery_detail';
import RadioaktivitaPage from '../pages/radioaktivita';
import RadioaktivitaChartPage from '../pages/radioaktivita-chart';
import MeteoSuchoPage from '../pages/meteo-sucho';
import MeteoSuchoDetailPage from '../pages/meteo-sucho-detail';
import KvalitaPodzemejVody from '../pages/pzv-dyn';
import KvalitaPodzemejVodyDetail from '../pages/pzv-dyn-detail';
import LmsMetarPage from '../pages/lms-metar';
import LmsTafPage from '../pages/lms-taf';
import LmsSigmet from '../pages/lms-sigmet';
import LmsSurfana from '../pages/lms-surfana';

import NotFoundPage from '../pages/404';

var routes = [
  {
    path: '/m/',
    component: HomePage,
  },
  {
    path: '/',
    component: HomePage,
  },
  {
    path: '/panel-left/',
    component: PanelLeft,
  },
  {
    path: '/aktualne-pocasie/',
    component: AktualnePocasiePage,
  },
  {
    path: '/aktualne-pocasie/:station_id',
    component: AktualnePocasieDetailPage,
  },
  {
    path: '/predpoved-pocasia/',
    component: PredpovedPocasiaPage,
  },
  {
    path: '/textova-predpoved/',
    component: TextovaPredpovedPage,
  },
  {
    path: '/meteogramy/',
    component: MeteogramyPage,
  },
  {
    path: '/a-laef/',
    component: AlaefPage,
  },
  {
    path: '/tlakove-pole/',
    component: TlakovePolePage,
  },
  {
    path: '/ozon-a-uv-index/',
    component: OzonAUVIndexPage,
  },
  {
    path: '/ozon/',
    component: OzonPage,
  },
  {
    path: '/uv-index/',
    component: UVIndexPage,
  },
  {
    path: '/snehove-spravodajstvo/',
    component: SnehoveSpravodajstvoPage,
  },
  {
    path: '/radary/',
    component: RadaryPage,
  },
  {
    path: '/druzice/',
    component: DruzicePage,
  },
  {
    path: '/meteo-vystrahy/',
    component: MeteoVystrahyPage,
  },
  {
    path: '/meteo-vystrahy/:region',
    component: MeteoVystrahyDetailPage,
  },
  {
    path: '/webkamery',
    component: WebkameryPage,
  },
  {
    path: '/webkamery/:id',
    component: WebkameryDetailPage,
  },
  {
    path: '/radioaktivita',
    component: RadioaktivitaPage,
  },
  {
    path: '/radioaktivita/:station_id',
    component: RadioaktivitaChartPage,
  },
  {
    path: '/meteo-sucho',
    component: MeteoSuchoPage,
  },
  {
    path: '/meteo-sucho/detail',
    popup: {
      component: MeteoSuchoDetailPage,
    }
  },
  {
    path: '/lms-metar',
    component: LmsMetarPage,
  },
  {
    path: '/lms-taf',
    component: LmsTafPage,
  },
  {
    path: '/lms-sigmet',
    component: LmsSigmet,
  },
  {
    path: '/lms-surfana',
    component: LmsSurfana,
  },
  {
    path: '/vodne-stavy/',
    component: VodneStavyPage,
  },
  {
    path: '/vodne-stavy/:station_id',
    component: VodneStavyChartPage,
  },
  {
    path: '/uhrny-zrazok/',
    component: UhrnyZrazokPage,
  },
  {
    path: '/uhrny-zrazok/:station_id',
    component: UhrnyZrazokChartPage,
  },
  {
    path: '/hydro-vystrahy/',
    component: HydroVystrahyPage,
  },
  {
    path: '/hydro-spravodajstvo/',
    component: HydroSpravodajstvoPage,
  },
  {
    path: '/hydro-situacia/',
    component: HydroSituaciaPage,
  },  {
    path: '/hydro-nadrze/',
    component: HydroNadrzePage,
  },
  {
    path: '/hydro-vystrahy/:region',
    component: HydroVystrahyDetailPage,
  },
  {
    path: '/situacia-na-vodnych-tokoch/',
    component: SituaciaNaVodnychTokochPage,
  },
  {
    path: '/situacia-na-vodnych-tokoch/:station_id/:selected_year?',
    component: SituaciaNaVodnychTokochChartPage,
  },
  {
    path: '/situacia-na-vodnych-tokoch-mesacna/:station_id/:selected_year?',
    component: SituaciaNaVodnychTokochMesacnaChartPage,
  },
  {
    path: '/podzemne-vody/',
    component: PodzemneVodyPage,
  },
  {
    path: '/kvalita-podzemnej-vody/',
    component: KvalitaPodzemejVody,
  },
  {
    path: '/kvalita-podzemnej-vody/detail/:rok/:cisloObjektu/:parentSelectedSkupina?',
    component: KvalitaPodzemejVodyDetail,
  },
  {
    path: '/podzemne-vody/:station_id',
    component: PodzemneVodyChartPage,
  },
  {
    path: '/smogovy-system/',
    component: SmogovySystemPage,
  },
  {
    path: '/smogovy-system/:station_id',
    component: SmogovySystemDetailPage,
  },
  {
    path: '/kvalita-ovzdusia/',
    component: KoTabulka,
  },
  {
    path: '/kvalita-ovzdusia/detail/:station_id',
    component: KoDetail,
  },
  {
    path: '/kvalita-ovzdusia/detail/:station_id/:pollutant_id',
    component: KoDetail,
  },
  /*
  {
    path: '/request-and-load/user/:userId/',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Router instance
      var router = this;

      // App instance
      var app = router.app;

      // Show Preloader
      app.preloader.show();

      // User ID from request
      var userId = routeTo.params.userId;

      // Simulate Ajax Request
      setTimeout(function () {
        // We got user data from request
        var user = {
          firstName: 'Vladimir',
          lastName: 'Kharlampidi',
          about: 'Hello, i am creator of Framework7! Hope you like it!',
          links: [
            {
              title: 'Framework7 Website',
              url: 'http://framework7.io',
            },
            {
              title: 'Framework7 Forum',
              url: 'http://forum.framework7.io',
            },
          ]
        };
        // Hide Preloader
        app.preloader.hide();

        // Resolve route to load page
        resolve(
          {
            component: RequestAndLoad,
          },
          {
            context: {
              user: user,
            }
          }
        );
      }, 1000);
    },
  },

   */
  {
    path: '(.*)',
    component: NotFoundPage,
  }
];

export default routes;
